module.exports = __webpack_public_path__ + "img/camera_button_recording.84bec9fb.svg";